import { Injectable } from '@angular/core';
import { GetMeResponse } from '../users/users.service'; // For GetMeResponse type

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  private readonly currentUserDetailsKey = 'currentUserDetails';
  private readonly currentUserDetailsCachedAtKey = 'currentUserDetailsCachedAt';

  constructor() { }

  public getCachedUserDetails(): GetMeResponse | null {
    const cachedData = localStorage.getItem(this.currentUserDetailsKey);
    if (cachedData) {
      try {
        return JSON.parse(cachedData) as GetMeResponse;
      } catch (e) {
        console.error('[CacheService] Error parsing cached user details:', e);
        localStorage.removeItem(this.currentUserDetailsKey); // Clear corrupted data
        return null;
      }
    }
    return null;
  }

  public setCachedUserDetails(userDetails: GetMeResponse): void {
    try {
      localStorage.setItem(this.currentUserDetailsKey, JSON.stringify(userDetails));
      localStorage.setItem(this.currentUserDetailsCachedAtKey, Date.now().toString());
    } catch (e) {
      console.error('[CacheService] Error saving user details to cache:', e);
    }
  }

  public clearCachedUserDetails(): void {
    localStorage.removeItem(this.currentUserDetailsKey);
    localStorage.removeItem(this.currentUserDetailsCachedAtKey);
    console.log('[CacheService] Cleared cached user details.');
  }

  public getCachedUserDetailsCachedAt(): number | null {
    const ts = localStorage.getItem(this.currentUserDetailsCachedAtKey);
    if (!ts) return null;
    const parsed = Number(ts);
    return isNaN(parsed) ? null : parsed;
  }
}
